import React from 'react';
import './style.css';

export enum ButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DESTRUCTIVE = 'destructive',
  DISABLED = 'disabled',
}

interface PropsType {
  isLoading?: boolean;
  btnStyle: string;
  btnText: string;
  btnType: JSX.IntrinsicElements['button']['type'];
  className?: string;
  name?: string;
  handleClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
}

const Button: React.FunctionComponent<PropsType> = (props: PropsType) => {
  const {
    isLoading,
    btnStyle,
    btnText,
    btnType,
    className,
    name,
    handleClick,
  } = props;
  const buttonStyle = (type: string): string => {
    switch (type) {
      case ButtonTypes.PRIMARY:
        return 'text-background-milk bg-celtic-blue-primary hover:bg-celtic-blue-medium-tint-1 active:bg-celtic-blue-shade hover:shadow';
      case ButtonTypes.SECONDARY:
        return 'text-celtic-blue-primary border border-solid border-celtic-blue-primary bg-background-milk hover:bg-celtic-blue-light-tint-2 active:bg-celtic-blue-light-tint-1 hover:shadow';
      case ButtonTypes.DESTRUCTIVE:
        return 'text-background-milk bg-red-primary hover:bg-red-medium-tint-1 active:bg-red-shade';
      case ButtonTypes.DISABLED:
        return 'text-background-milk bg-background-platinum';
      default:
        return '';
        break;
    }
  };
  return (
    // eslint-disable-next-line react/button-has-type
    <button
      className={`${className} trans btn button-text h-12 px-10 ${buttonStyle(
        btnStyle
      )} rounded outline-none focus:outline-none`}
      type={btnType}
      disabled={isLoading}
      data-testid={name}
      onClick={handleClick}
    >
      {isLoading ? <span className="spinner" /> : <span>{btnText}</span>}
    </button>
  );
};
Button.defaultProps = {
  isLoading: false,
  btnText: 'Button',
  btnType: 'button',
  handleClick: (): void => {
    //
  },
};
export default Button;
